import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Articles from "@/pages/Articles";
import Kits from "@/pages/Kits";
import Movements from "@/pages/Movements";
import ImportPage from "@/pages/Import";
import Assistant from "@/pages/Assistant";
import Scanner from "@/pages/Scanner";
import Users from "@/pages/Users";

function AdminOnly({ children }) {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/" replace />;
}

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="flex h-screen items-center justify-center text-slate-500" data-testid="auth-loading">Chargement…</div>;
  if (!user) return <Navigate to="/connexion" replace />;
  return <Layout><Outlet /></Layout>;
}

function PublicOnly() {
  const { user } = useAuth();
  if (user === null) return null;
  return user ? <Navigate to="/" replace /> : <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/connexion" element={<PublicOnly />} />
            <Route element={<Protected />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/kits" element={<Kits />} />
              <Route path="/mouvements" element={<Movements />} />
              <Route path="/import" element={<ImportPage />} />
              <Route path="/scanner" element={<Scanner />} />
              <Route path="/utilisateurs" element={<AdminOnly><Users /></AdminOnly>} />
              <Route path="/assistant" element={<Assistant />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
